/**
 * @module middleware
 */

// classic middleware
import { browserHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
import dynamicMiddlewares from 'redux-dynamic-middlewares';
import createSagaMiddleware from 'redux-saga';

import api from './Api';
import error from './Error';
import logging from './Logging';
import serviceError from './ServiceError';
import sharedState from './SharedState';
import thunkPromise from './ThunkPromise';
import timer from './Timer';

export default function () {
  const reduxRouterMiddleware = routerMiddleware(browserHistory);
  const sagaMiddleware = createSagaMiddleware();

  const middleware = Object.freeze([
    thunkPromise,
    sharedState,
    logging,
    error,
    serviceError(history, api),
    timer,
    dynamicMiddlewares,
    sagaMiddleware,
    reduxRouterMiddleware,
  ]);

  return {
    middleware,
    reduxRouterMiddleware,
    sagaMiddleware,
  };
}
